import { View } from 'react-native'
import React, { useState } from 'react'
import {
  columnWidth,
  permissionsHeaders,
  rowHeaderWidth
} from './PermissionsRowHeaders'
import { DataTable } from 'react-native-paper'
import { MSFESTristateCheckbox } from '../MSFESTristateCheckbox'
import spacing from '../../styles/spacing'
import colors from '../../styles/colors'

const getLocalState = (defaultValue) => {
  const initialState = {}
  for (const header of permissionsHeaders) {
    initialState[header.key] = defaultValue?.[header.key] ?? null
  }
  return initialState
}

const nextState = (state, isTriState) => {
  if (state === null) {
    return true
  }
  if (state === false) {
    return null
  }
  return isTriState ? false : null
}

export const PermissionsBlock = ({
  entityType,
  group,
  systemPermissionName,
  onChanged,
  defaultValue
}) => {
  const [localState, setLocalState] = useState(getLocalState(defaultValue))

  const recordChanges = (changes) => {
    setLocalState(changes)
    onChanged(changes)
  }
  return (
    <View
      style={{
        flex: 1,
        width: '100%',
        backgroundColor: group ? colors.white : 'transparent',
        marginTop: group ? -spacing.m2 : 0
      }}
    >
      <DataTable.Row>
        <DataTable.Title style={{ minWidth: rowHeaderWidth }}>
          {entityType?.label}
          {systemPermissionName?.name}
        </DataTable.Title>
        {permissionsHeaders.map((r) => {
          const thisPermissionIsDisabled = !systemPermissionName
            ? false
            : systemPermissionName.availablePermissions.find(
                (ap) => ap.key === r.key
              )
            ? false
            : true
          return (
            <DataTable.Cell
              key={r.key}
              style={{
                maxWidth: columnWidth,
                width: columnWidth,
                paddingHorizontal: 1
              }}
            >
              {thisPermissionIsDisabled ? (
                <View />
              ) : (
                <MSFESTristateCheckbox
                  radio={false}
                  onPress={() => {
                    recordChanges({
                      ...localState,
                      [r.key]: nextState(
                        localState[r.key],
                        r.isTriState === false ? false : true
                      )
                    })
                  }}
                  checkState={localState[r.key]}
                />
              )}
            </DataTable.Cell>
          )
        })}
        <DataTable.Title style={{ flex: 10 }}></DataTable.Title>
      </DataTable.Row>
    </View>
  )
}
